import styled from "styled-components";
import { Header2 } from "./Header";
export const CenteredHeader = styled(Header2) `
  text-align: center;
`;
